module.exports = __webpack_public_path__ + "static/media/logo.6324a3d7.svg";